import * as Redux from 'redux'
import * as OtherClicks from './other-clicks'
import * as Promotions from './promotions'
import * as Today from './today'
import * as TopArticles from './top-articles'
import * as TopSources from './top-sources'
import * as TopTopics from './top-topics'

export const reducer = Redux.combineReducers({
  otherClicks: OtherClicks.reducer,
  promotions: Promotions.reducer,
  today: Today.reducer,
  topArticles: TopArticles.reducer,
  topSources: TopSources.reducer,
  topTopics: TopTopics.reducer,
})



// WEBPACK FOOTER //
// ./src/pages/reports/reducer.ts